import React, { Component } from 'react'
import { Table, Tooltip } from "@tinper/next-ui";

export default class detailTable extends Component {
  state = {
    dataDetail: [],
    columnsArr: [
      { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009C', '页签名称', undefined, {returnDom: true, placement: 'top'}), dataIndex: "sheetName", key: "sheetName" },
      // { title: "总行数", dataIndex: "totalCount", key: "totalCount" },
      { dataIndex: 'required', key: 'required', title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009E', '必填为空', undefined, {returnDom: true, placement: 'top'}),
        render: (text, _record, _index) => {
          return text
            ? (<Tooltip inverse overlayStyle={{ maxWidth: '500px' }} overlay={this.renderChildTable(_record['requiredInfo'])}>
              <span style={{
                display: 'inline-block',
                maxWidth: '100%',
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: 'red',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>{text}</span>
            </Tooltip>)
            : 0;
        }
      },
      { dataIndex: 'format', key: 'format', title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009F', '格式异常', undefined, {returnDom: true, placement: 'top'}),
        render: (text, _record, _index) => {
          return text
            ? (<Tooltip overlayStyle={{ maxWidth: '500px' }} inverse overlay={this.renderChildTable(_record['formatInfo'])}>
              <span style={{
                display: 'inline-block',
                maxWidth: '100%',
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: 'red',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>{text}</span>
            </Tooltip>)
            : 0;
        }
      },
      { dataIndex: 'attribute', key: 'attribute', title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80099', '属性不存在', undefined, {returnDom: true, placement: 'top'}),
        render: (text, _record, _index) => {
          return text
            ? (<Tooltip inverse overlayStyle={{ maxWidth: '500px' }} overlay={this.renderChildTable(_record['attributeInfo'])}>
              <span style={{
                display: 'inline-block',
                maxWidth: '100%',
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: 'red',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>{text}</span>
            </Tooltip>)
            : 0;
        }
      },
      { dataIndex: 'unique', key: 'unique', title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009B', '不唯一', undefined, {returnDom: true, placement: 'top'}),
        render: (text, _record, _index) => {
          return text
            ? (<Tooltip inverse overlayStyle={{ maxWidth: '500px' }} overlay={this.renderChildTable(_record['uniqueInfo'])}>
              <span style={{
                display: 'inline-block',
                maxWidth: '100%',
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: 'red',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>{text}</span>
            </Tooltip>)
            : 0;
        }
      }
    ],
    columns: [
      {
        title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009D', '序号', undefined, {returnDom: true, placement: 'top'}), dataIndex: "index", key: "index", width: 80,
        render (_text, _record, index) {
          return index + 1;
        }
      },
      { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A0', '字段', undefined, {returnDom: true, placement: 'top'}), dataIndex: "columnName", key: "columnName", width: 100 },
      { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A1', '所在行', undefined, {returnDom: true, placement: 'top'}), dataIndex: "row", key: "row", width: 100 },
      { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8009A', '错误信息', undefined, {returnDom: true, placement: 'top'}), dataIndex: "errorMessage", key: "errorMessage", width: 200 }
    ]
  }

  componentDidMount () {
    const { errorStats } = this.props
    // let columnsArr = []
    // errorStats[0].errorTypes.forEach(val => {
    //     columnsArr.push({
    //         dataIndex: val.errorType.toLowerCase(),
    //         key: val.errorType.toLowerCase(),
    //         title: val.errorName,
    //         width: 100
    //     })
    // })
    const errArr = []
    errorStats.forEach((item, index) => {
      const infos = {}
      item.errorTypes.forEach(val => {
        infos[val.errorType.toLowerCase()] = val.errorCount
        infos[val.errorType.toLowerCase() + 'Info'] = val.errors
      })
      errArr.push({
        sheetName: item.sheetName,
        totalCount: item?.totalCount || '--',
        ...infos
      })
    })
    console.log('dataDetail---', errArr)
    this.setState({
      dataDetail: errArr
      // columnsArr
    })
  }

  renderChildTable = (data) => {
    const { columns } = this.state
    return (
      <Table
        className="child-table"
        columns={ columns }
        data={ data }
      />
    )
  }

  render () {
    const { dataDetail, columnsArr } = this.state
    return (
      <div className='detail-table'>
        <Table
          className="bar-table"
          columns={ columnsArr }
          data={ dataDetail }
        />
      </div>
    )
  }
}
